import { CardPaymentStatus } from './enums'
import { calculateAutomaticItemFromValues } from './item-utils'
import { Day } from './time'

export const isSuccessful = (status: CardPaymentStatus | undefined) => {
    return status === CardPaymentStatus.settled
}

export const getAmountWithoutVat = (isVatPayer: boolean, vatPercentage: number) => {
    if (isVatPayer) {
        return 6.99
    }

    // For non-VAT payers, we adjust the base price so the final price would be as close to 6.99 as possible
    if (vatPercentage === 24) {
        return 5.64 // 5.64 * 1.24 ~= 6.99
    } else if (vatPercentage === 22) {
        return 5.73 // 5.73 * 1.22 ~= 6.99
    } else if (vatPercentage === 20) {
        return 5.82 // 5.82 * 1.20 ~= 6.98
    } else {
        throw new Error(`Unexpected VAT percentage: ${vatPercentage}`)
    }
}

export const getAmountWithVat = (isVatPayer: boolean, vatPercentage: number) => {
    const amountWithoutVat = getAmountWithoutVat(isVatPayer, vatPercentage)
    const totals = calculateAutomaticItemFromValues(1, amountWithoutVat, 0, vatPercentage)
    return totals.payableWithVat
}

export const getPaymentDate = (firstPayment: Day, monthsPaid: number) => {
    const dayOfMonth = firstPayment.dayOfMonth()

    const endOfPaid = firstPayment.firstOfMonth().addMonths(monthsPaid).lastOfMonth()

    if (endOfPaid.dayOfMonth() > dayOfMonth) {
        return endOfPaid.withDayOfMonth(dayOfMonth)
    } else {
        return endOfPaid
    }
}
